module.exports = __webpack_public_path__ + "media/Handshake.b21c49cb.svg";